<template>
  <div>
    <div class="title" style="margin: 30px 50px ;font-size: 20px; color: #1890ff">
      <span style="margin-right: 50px">{{ $t('runningData.machineCode')}}: {{ machineId }}</span>
      <span>{{ $t('history.machineType')}}: {{ machineType }}</span>
    </div>
    <div style=" margin-bottom: 30px; margin-left: 50px">
      <!-- <a-month-picker  :default-value="moment(new Date(), 'YYYY-MM')" @change="onChange"/> -->
      <a-range-picker
        :default-value="[moment(new Date(), 'YYYY-MM-DD').add(-7,'days'), moment(new Date(), 'YYYY-MM-DD')]"
        @change="onChange"
      />
      <!-- <a-select show-search mode="multiple" style="min-width: 200px; margin-left: 10px" placeholder="请选择参数" >
        <a-select-option v-for="i in points" :key="i.code" :label="i.name">
          {{ i.name }}
        </a-select-option>
      </a-select> -->
      <a-select
        show-search
        :placeholder="$t('placeholder.points')"
        style="min-width: 240px; margin-left: 10px"
        mode="multiple"
        v-model="selectedPoints"
        :filter-option="filterOption"
        :maxTagCount="5"
        @change="handleSelectedPointsChange"
      >
        <a-select-option v-for="i in points" :key="i.code" :value="i.code">
          {{ i[lang] }}
        </a-select-option>
      </a-select>
      <a-button @click="savePoints" style="margin-left: 20px" type="primary">{{ $t('history.savePoints') }}</a-button>
      <a-button @click="getHistroyList" style="margin-left: 10px" type="primary">{{ $t('buttons.search') }}</a-button>
      <a-button style="margin: 10px" key="back" @click="historyCancel">{{ $t('buttons.goBack') }}</a-button>
      <a-button key="submit" type="primary" @click="exportToExcel">{{ $t('buttons.export') }}</a-button>
      <a-button style="margin-left: 10px" type="primary" @click="showRateMask">{{ $t('device.count') }}</a-button>
      <div class="exportData">
        <label style="width: 130px; display: inline-block">{{ $t('history.export') }}：</label>
        <a-input-number v-model="gap" :min="1" />
      </div>
      <br />
      <div class="dataRange">
        <label>{{ $t("history.dataRange" )}}</label>
        <a-button type="primary" @click="addRangeOption">{{ $t("buttons.add") }}</a-button>
        <a-button style="margin-left: 10px;" type="primary" @click="filterData">{{ $t("history.filter") }}</a-button>
        <ul class="dataRangeGroup">
          <li v-for="(r, i) in rangeOptions" :key="r.id">
            <div>
              <label>{{ $t('modification.points') }}: </label>
              <a-select style="width: 150px;" v-model="r.pointCode">
                <a-select-option v-for="p in pointstoFilter" :key="p.code">
                  {{ p[lang] }}
                </a-select-option>
              </a-select>
            </div>
            <div style="flex: 13; display: flex; justify-content: space-between; align-items: center; padding-left: 10px">
              <label>{{ $t("history.range") }}</label>
              <a-input v-model="r.startValue" style="width: 60px;" />
              <span>~</span>
              <a-input v-model="r.endValue" style="width: 60px;" />
            </div>
            <div style="flex: 1; display: flex; justify-content: space-between; align-items: center; padding-left: 10px">
              <a-icon class="close_icon" type="close-circle" @click="deleteRangeOption(i)" />
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div v-show="isLoading" style="text-align: center">
      <a-progress id="progress" :percent="percent" style="width:500PX" status="active" />
    </div>
    <ul v-show="isContentShow" class="chartsContainer">
      <li v-for="i in pointsOfcharts" :key="i" :id="i"></li>
    </ul>
    <a-modal v-model="rateShow" :width="600" :title=" $t('device.count')" :footer="null">
      <div>
        <h2 style="color: #333; font-weight: normal">
          {{$route.params.name}}
          <br />
          <label>{{ $t('history.dateRange') }}</label>
          <el-date-picker
            v-model="rateDateRange"
            type="datetimerange"
            align="right"
            unlink-panels
            style="margin: 20px 0"
          />
          <br />
          <label style="margin-bottom: 20px">{{ $t('device.acquisitionInterval') }}</label>
          <a-select style="width: 100px; margin-bottom: 20px" v-model="rateInterval">
            <a-select-option value="10">10</a-select-option>
            <a-select-option value="20">20</a-select-option>
            <a-select-option value="30">30</a-select-option>
            <a-select-option value="60">60</a-select-option>
            <a-select-option value="180">180</a-select-option>
            <a-select-option value="300">300</a-select-option>
            <a-select-option value="600">600</a-select-option>
          </a-select>
          <span style="margin-left: 10px; font-size: 16px">{{ $t('common.second') }}</span>
          <br />
          <a-button :loading="isRateLoading" type="primary" style="margin-bottom: 20px" @click="setRate">{{ $t('history.calculate') }}</a-button>
          <br />
          {{ $t('device.expection') }}{{ rateTarget }}
          <br />
          {{ $t('device.real') }}{{ rateResult }}
          <br />
          {{ $t('device.rate') }}{{ rate }}
        </h2>
      </div>
    </a-modal>
  </div>
</template>

<script>
import moment from "moment"
import echarts from "@/plugins/chart"
import formatDate from '@/components/function/formatDate.js'
import { getDeviceHistoryData, searchDeviceList } from "@/api/device"
import { getProtocol } from "@/api/protocol"
import { getDict } from "@/api/dict"
import { nanoid } from "nanoid"
import * as XLSX from '@/plugins/export-excel'

const statusMap = {} 

export default {
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang() {
      this.map = {}
      this.points.forEach(i => {
        this.map[i.code] = i[this.lang]
      })
      this.renderChart()
    }
  },
  async mounted() {
    this.machineId = this.$route.params.machineId
    this.machineType = this.$route.params.machineType
    const { data } = await searchDeviceList(1, 10, {
      query: [],
      filter: [
        {
          field: 'id',
          value: this.$route.params.id
        }
      ],
      sort: []
    })
    this.d = data.records[0]
    try {
      const { data } = await getDict("zh-CN", "deviceStatus");
      data.content.forEach(c => {
        statusMap[c.value] = c.text;
      })
      
    } catch (e) {
      console.log(e);
    }
    // getDeviceHistoryData({
    //   deviceId: this.machineId,
    //   startTime: 1692028800000,
    //   endTime: 1692111600000,
    //   point: 'flow'
    // }).then(({ data }) => {
    //   console.log(data)
    // }).catch(() => {})
    // this.port_no = this.$route.params.port_no
    // compressorApi.setdata(this.port_no).then(data  => {
    //   this.setdata = data.data
    getProtocol(data.records[0].protocolCode).then(({ data }) => {
      this.points = data.points.filter(p => p.read !== false && p.dataWrite !== 2).map(item => {
        item.zh = item.name
        item.en = item.details?.find(d => d.locale === 'en-US')?.name
        if (!item.en) {
          item.en = item.zh
        }
        return item
      })
      let points = localStorage.getItem("points")
      if (points) {
        points = JSON.parse(points)
        this.selectedPoints = points.filter(p => this.points.find(pp => pp.code === p))
      } else {
        points = []
      }
      if (!this.selectedPoints.length) {
        this.selectedPoints = this.points.slice(0, 9).map(p => p.code)
      }
      this.map = {}
      this.points.forEach(i => {
        this.map[i.code] = i[this.lang] + (i.unit ? `(${i.unit})` : '')
      })
      this.pointstoFilter = this.points.filter(p => this.selectedPoints.find(sp => sp === p.code))
      this.getHistroyList()
    });
    //   this.date = moment(new Date()).format('YYYY-MM')
    //   this.getHistroyList(this.machineId, this.date, this.setdata[0].data0a)
    // }).catch(() => {
    //   // this.$message.error("请求失败")
    // })
  },
  data() {
    return {
      date: "",
      points: [],
      pointsOfcharts: [],
      selectedPoints: [],
      percent: 0,
      machineId: "",
      machineType: "",
      port_no: "",
      isLoading: false,
      setdata: [{}],
      historyList: [{}],
      isContentShow: false,
      title: [
        "压力(MPa)",
        "频率(Hz)",
        "输出电流(A)",
        "温度(℃)",
        "母线电压(V)",
        "负载率(%)",
        "保养时间(H)",
        "输出功率(kW)",
        "运行累时(H)"
      ],
      loading: false,
      historydata: [[], [], [], [], [], [], [], []],
      myChart: [],
      option: {
        title: {
          text: "Beijing AQI",
          left: "1%"
        },
        tooltip: {
          trigger: "axis"
        },
        toolbox: {
          right: 10,
          feature: {
            dataZoom: {
              yAxisIndex: "none"
            },
            restore: {},
            saveAsImage: {}
          }
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            xAxisIndex: [0],
            start: 99,
            end: 100
          },
          {
            // 第一个 dataZoom 组件
            type: "inside",
            xAxisIndex: [0],
            start: 99,
            end: 100
          }
        ],
        xAxis: {
          type: "category",
          data: [],
          axisLine: {
            onZero: false
          }
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            data: [],
            type: "line"
          }
        ]
      },
      rateShow: false,
      rateDateRange: [],
      isRateLoading: false,
      rateTarget: '',
      rateResult: '',
      rate: '',
      rateInterval: '',
      gap: 1,
      rangeOptions: []
    };
  },
  created() {
    this.startDatetime = +new Date(moment(new Date(), 'YYYY-MM-DD').add(-7,'days'))
    this.endDatetime = +new Date(moment(new Date(), 'YYYY-MM-DD'))
    if (this.$route.params.intervalTime) {
      this.rateInterval = this.$route.params.intervalTime
    }
  },
  beforeDestroy() {
    this.myChart.forEach(c => {
      c.clear();
      c.dispose();
      c = null;
    });
  },
  methods: {
    formatDate,
    moment,
    exportToExcel() {
      const headerList = [
        this.$t('device.code'),
        this.$t('customer.company'),
        this.$t('history.machineType')
      ];
      for (let i = 0; i < this.selectedPoints.length; i++) {
        headerList.push(this.map[this.selectedPoints[i]])
      }
      headerList.push(this.$t('dataReport.datetime'))
      // const bodyList = [
      //   ['新狗', '18', '1993'],
      //   ['蜡笔', '22', '2000']
      // ]// 主体内容部分  this.historyList.length
      let excelListContent = [headerList]; // 声明一个空数组准备将头部和内容柔和在一起
      const history = []
      let h
      const dataUnitsGap = (this.$route.params.intervalTime || 180) * this.gap * 1000
      if (this.historyList.length) {
        history[0] = this.historyList[0]
        let start = (+new Date(this.historyList[0].time) + dataUnitsGap), end = (+new Date(this.historyList[this.historyList.length - 1].time) + dataUnitsGap), left = 0
        for (let i = start; i < end; i += dataUnitsGap) {
          for (let j = left; j < this.historyList.length; j++) {
            h = this.historyList[j]
            if (+new Date(h.time) > i) {
              if (j - left <= 1) {
                break
              }
              left = j - 1
              h = this.historyList[left]
              history.push(h);
              break
            }
            if (+new Date(h.time) === i) {
              left = j
              history.push(h);
              break
            }
          }
        }
      }
      
      let data

      for (let i = 0; i < history.length; i++) {
        data = []
        data.push(this.d.code)
        data.push(this.d.customer.company)
        data.push(this.d.model)
        for (let j = 0; j < this.selectedPoints.length; j++) {
          data.push(+history[i][this.selectedPoints[j]])
        }
        data.push(new Date(history[i].time).toLocaleString())
        excelListContent.push(data)
      }
  
      const wb = XLSX.utils.book_new()
      // 创建一个工作表
      const ws = XLSX.utils.aoa_to_sheet(excelListContent)

      // 遍历工作表中的所有单元格
      for (const cellAddress in ws) {
          if (cellAddress[0] === '!') continue // 忽略特殊单元格
          const cell = ws[cellAddress]

          // 检查单元格的值是否是可以转换为数字的字符串
          if (cell.v && /^[^a-zA-Z]*$/.test(cell.v) && !isNaN(cell.v)) {
              cell.t = 'n' // 将单元格类型设置为数字
              cell.v = parseFloat(cell.v);// 确保单元格的值为数字
          }
      }

      // 将工作表添加到工作簿中
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1")

      // 导出 Excel 文件
      XLSX.writeFile(wb, this.machineId  + this.$t('device.history') + this.date + '.xlsx')
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    onChange(date, dateString) {
      this.startDatetime = +new Date(dateString[0] + " 00:00:00");
      this.endDatetime = +new Date(dateString[1] + " 23:59:59");
      console.log(this.startDatetime, this.endDatetime);
    },
    onClose() {
      this.visible = false;
    },
    handleSelectedPointsChange() {
      console.log(this.selectedPoints);
    },
    historyCancel(e) {
      this.$router.back();
    },
    async getHistroyList(currentData, date, data0a) {
      this.myChart.forEach(c => {
        c.clear();
        c.dispose();
        c = null;
      });
      this.myChart = []
        this.isLoading = true
      this.pointsOfcharts = [...this.selectedPoints]
      const start = () => {
        this.percent++;
        if (this.percent > 98) {
          clearTimeout();
          return;
        }
        setTimeout(start, 500);
      };
      this.percent = 0;
      setTimeout(start, 500);
      const params = {
        deviceId: this.$route.params.id,
        pointCode: this.selectedPoints + '',
        startTime: this.startDatetime,
        endTime: this.endDatetime
      }
      this.historydata = []
      this.historydata = this.selectedPoints.map(() => [])
      this.historydata.push([])
      try {
        const historyList = await getDeviceHistoryData(params)
        this.historyList = historyList.data
        for (let i = 0; i < this.historyList.length; i++) {
          this.historydata[0].push((new Date(this.historyList[i].time)).toLocaleString())
          for (let j = 0; j < this.selectedPoints.length; j++) {
            this.historydata[j + 1].push(this.historyList[i][this.selectedPoints[j]])
          }
        }
        this.percent = 100
        this.isLoading = false
        this.isContentShow = true
        this.$nextTick(this.renderChart)
      } catch(e) {
        console.log(e)
      }
      // compressorApi
      //   .history(currentData, date)
      //   .then(({ data }) => {
      //     this.historyList = data;
      //     this.historydata = [[], [], [], [], [], [], [], [], [], []];
      //     for (let i = 0; i < this.historyList.length; i++) {
      //       this.historydata[0].push(
      //         moment(this.historyList[i].settime, "YYYYMMDDHHmmss").format(
      //           "MM-DD HH:mm"
      //         )
      //       );
      //       this.historydata[1].push(this.historyList[i].pressure);
      //       this.historydata[2].push(this.historyList[i].out_rate);
      //       this.historydata[3].push(this.historyList[i].out_electric_i);
      //       this.historydata[4].push(this.historyList[i].temperature);
      //       this.historydata[5].push(this.historyList[i].mu_electric_u);
      //       this.historydata[7].push(this.historyList[i].maintain_time);
      //       this.historydata[8].push(this.historyList[i].out_power);
      //       this.historydata[9].push(this.historyList[i].run_time);
      //       if (data0a === "0") {
      //         this.historydata[6].push(0);
      //       } else {
      //         this.historydata[6].push(
      //           (parseInt(this.historyList[i].out_rate) /
      //             parseInt(data0a).toFixed(2)) *
      //             100
      //         );
      //       }
      //       // this.historydata[6].push(this.historyList[i].out_power)
      //     }
      //     this.loading = false;
      //   })
      //   .then(() => {
      //     for (let i = 0; i < 9; i++) {
      //       this.myChart[i] = echarts.init(
      //         document.getElementById(`chart${i}`)
      //       );
      //       this.myChart[i].group = "group";
      //       echarts.connect("group");
      //       this.option.title.text = this.title[i];
      //       this.option.xAxis.data = this.historydata[0];
      //       this.option.series[0].data = this.historydata[i + 1];
      //       this.myChart[i].setOption(this.option);
      //     }
      //     this.percent = 100;
      //   })
      //   .catch(() => {
      //     this.$message.error("请求失败", 1);
      //   });
    },
    renderChart() {
      // this.completeData()
      for (let i = 0; i < this.selectedPoints.length; i++) {
        const c = this.selectedPoints[i]
        if (!this.myChart[i]) {
          this.myChart[i] = echarts.init(
            document.getElementById(c)
          )
        }
        this.myChart[i].group = "group"
        echarts.connect("group")
        
        this.option.title.text = this.map[c]
        this.option.xAxis.data = this.historydata[0]
        this.option.series[0].name = this.map[c]
        this.option.series[0].data = this.historydata[i + 1]
        this.myChart[i].setOption(this.option, { replaceMerge: ["series", "title"]})
      }
    },
    completeData() {
      let result = this.historydata.map(() => []), i, rateInterval = (this.rateInterval || 180) * 1000
      for (i = +new Date(this.historydata[0][0]); i >= this.startDatetime; i -= rateInterval) {
        result[0].unshift(new Date(i).toLocaleString())
        for (let k = 1; k < this.historydata.length; k++) {
          result[k].push("-")
        }
      }
      for (i = 0; i < this.historydata[0].length - 1; i++) {
        if ((new Date(this.historydata[0][i + 1]) - new Date(this.historydata[0][i])) > (rateInterval + 999)) {
          for (let j = +new Date(this.historydata[0][i]); j < +new Date(this.historydata[0][i + 1]); j += rateInterval) {
            result[0].push(new Date(j).toLocaleString())
            for (let k = 1; k < this.historydata.length; k++) {
              result[k].push("-")
            }
          }
        } else {
          for (let k = 0; k < this.historydata.length; k++) {
            result[k].push(this.historydata[k][i])
          }
        }
      }
      if ((new Date() - this.endDatetime) > (1000 + rateInterval)) {
        for (let i = +new Date(this.historydata[0].at(-1)) + rateInterval; i <= this.endDatetime; i += rateInterval) {
          result[0].push(new Date(i).toLocaleString())
          for (let k = 1; k < this.historydata.length; k++) {
            result[k].push("-")
          }
        }
      }
      this.historydata = result
    },
    showRateMask() {
      this.rateDateRange = [new Date(+new Date() - 24 * 3600000), new Date()]
      this.rateTarget = this.rateResult = this.rate = ''
      this.rateShow = true
    },
    closRate() {
      this.rateShow = false
      this.rateInterval = ''
    },
    async setRate() {
      if (!this.rateDateRange || this.rateDateRange.length < 2 || !this.rateInterval) {
        this.rateTarget = this.rateResult = '0'
        this.rate = '0%'
        return
      }
      this.isRateLoading = true
      try {
        const { data } = await getDeviceHistoryData({
          deviceId: this.$route.params.id,
          pointCode: this.selectedPoints + '',
          startTime: +this.rateDateRange[0],
          endTime: +this.rateDateRange[1]
        })
        if (data.length < 1) {
          this.rateTarget = Math.floor((+this.rateDateRange[1] - +this.rateDateRange[0]) / (this.rateInterval * 1000))
          this.rateResult = '0'
          this.rate = '0%'
          return
        }
        let result = 1
        const gap = this.rateInterval * 1000
        let start = (Math.floor(+new Date(data[0].time) / 1000) * 1000 + gap), end = (+new Date(data[data.length - 1].time) + gap), left = 0, h
        for (let i = start; i < end; i += gap) {
          for (let j = left; j < data.length; j++) {
            h = data[j]
            h.time = Math.floor(+new Date(h.time) / 1000) * 1000
            if (h.time > i) {
              if (j - left <= 1) {
                break
              }
              left = j - 1
              result++
              break
            }
            if (h.time === i) {
              left = j
              result++
              break
            }
          }
        }
        const target = Math.floor((+this.rateDateRange[1] - +this.rateDateRange[0]) / (this.rateInterval * 1000))
        this.rateTarget = target
        this.rateResult = result
        this.rate = (result / target * 100).toFixed(2) + '%'
      } catch(e) {
        console.log(e)
      } finally {
        this.isRateLoading = false
      }
    },
    savePoints() {
      let points = localStorage.getItem("points")
      if (points) {
        points = JSON.parse(points)
      } else {
        points = []
      }

      for (let i = 0; i < this.selectedPoints.length; i++) {
        if (!points.find(p => p === this.selectedPoints[i])) {
          points.push(this.selectedPoints[i])
        }
      }

      localStorage.setItem("points", JSON.stringify(points))
      this.$message.success(this.$t("history.success"))
    },
    addRangeOption() {
      this.rangeOptions.push({
        id: nanoid(),
        pointCode: "",
        startValue: null,
        endValue: null
      })
    },
    deleteRangeOption(i) {
      this.rangeOptions.splice(i, 1)
    },
    filterData() {
      const historyData = [[]].concat(this.selectedPoints.map(() => [[], []]))
      let h, r, min, max, flag, sp
      for (let i = 0; i < this.historyList.length; i++) {
        h = this.historyList[i]
        flag = true
        let j
        for (j = 0; j < this.rangeOptions.length; j++) {
          r = this.rangeOptions[j]
          if (r.pointCode) {
            if (isNaN(+r.startValue)) {
              min = -Infinity
            } else {
              min = Number(r.startValue)
            }
            if (isNaN(+r.endValue)) {
              max = Infinity
            } else {
              max = Number(r.endValue)
            }

            if (min > max) {
              let temp = min
              min = max
              max = temp
            }

            if (!(h[r.pointCode] >= min && h[r.pointCode] <= max)) {
              flag = false
              break
            }
          }
        }

        historyData[0].push(new Date(h.time).toLocaleString())

        for (let k = 0; k < this.selectedPoints.length; k++) {
          sp = this.selectedPoints[k]
          
          if (flag) {
            historyData[k + 1][0].push(h[sp])
            historyData[k + 1][1].push("-")
          } else {
            historyData[k + 1][0].push({
              value: h[sp],
              symbol: "none",
              label: {
                show: false
              }
            })
            historyData[k + 1][1].push(h[sp])
          }
        }
      }

      for (let i = 0; i < this.myChart.length; i++) {
        sp = this.selectedPoints[i]
        if (!this.myChart[i]) {
          this.myChart[i] = echarts.init(
            document.getElementById(sp)
          )
          this.myChart[i].group = "group"
          echarts.connect("group")
        }
        const option = {
          title: {
            text: this.map[sp],
            left: "1%"
          },
          tooltip: {
            trigger: "axis"
          },
          toolbox: {
            right: 10,
            feature: {
              dataZoom: {
                yAxisIndex: "none"
              },
              restore: {},
              saveAsImage: {}
            }
          },
          dataZoom: [
            {
              type: "slider",
              show: true,
              xAxisIndex: [0],
              start: 99,
              end: 100
            },
            {
              // 第一个 dataZoom 组件
              type: "inside",
              xAxisIndex: [0],
              start: 99,
              end: 100
            }
          ],
          xAxis: {
            type: "category",
            data: historyData[0],
            axisLine: {
              onZero: false
            }
          },
          yAxis: {
            type: "value"
          },
          series: [
            {
              data: historyData[i + 1][0],
              type: "line",
              zlevel: 1
            },
            {
              data: historyData[i + 1][1],
              type: "line",
              tooltip: {
                show: false
              },
              symbol: "none",
              zlevel: 2,
              lineStyle: {
                color: "red"
              }
            }
          ]
        }
        this.myChart[i].setOption(option)
      }
    }
  }
};
</script>

<style lang="less" scoped>
.title {
  color: #52c41a;
}
.chartsContainer {
  padding: 0;
  margin: 0;
  overflow: hidden;
  li {
    float: left;
    list-style: none;
    width: 550px;
    height: 300px;
    margin: 0 0 10px 10px;
  }
}
label {
  color: #333;
  font-size: 16px;
}
.exportData {
  display: inline-block;
  margin-left: 15px;
}
.dataRangeGroup {
  width: 95%;
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin-top: 15px;
  li {
    width: 30%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    &:nth-child(3n + 2) {
      margin: 0 5% 20px;
    }
    .close_icon {
      cursor: pointer;
    }
  }
}
</style>
